import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()

// Hide header and footer for portal routes
const isPortalRoute = computed(() => {
  return route.path.startsWith('/')
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("link", {
      href: "https://cdn.jsdelivr.net/npm/@mdi/font@5.x/css/materialdesignicons.min.css",
      rel: "stylesheet"
    }, null, -1)),
    _cache[1] || (_cache[1] = _createElementVNode("link", {
      href: "https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&family=Inter:wght@400;500;600&display=swap",
      rel: "stylesheet"
    }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      (!isPortalRoute.value)
        ? (_openBlock(), _createBlock(Header, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view),
      (!isPortalRoute.value)
        ? (_openBlock(), _createBlock(Footer, { key: 1 }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})